<template>
  <div class="material-detail-container">
    <!-- 顶部统一导航栏 -->
    <title-bar-back @back="onBack">
      <template slot="content">
        <div class="author-profile" v-if="pageData.creatorName">
          <img class="author-avatar" :src="pageData.headImage || defaultAvatar" />
          <div class="author-meta">
            <div class="author-name">{{ pageData.creatorName }}</div>
            <div class="post-time">{{ formatTime(pageData.gmtModified) }}</div>
          </div>
        </div>
      </template>
    </title-bar-back>

    <!-- 滚动内容区 -->
    <div class="scroll-content">
      <!-- 笔记类型富文本渲染 (model === 2) -->
      <div v-if="pageData.model === 2" class="rich-text-content">
        <div v-html="pageData.description" class="v-html-body"></div>
      </div>

      <!-- 素材类型渲染 (model !== 2) -->
      <div v-else class="material-media-content">
        <!-- 轮播图片 (type === 1) -->
        <div v-if="pageData.type === 1 && pageData.imageVideoList && pageData.imageVideoList.length > 0" class="swiper-box">
          <van-swipe :autoplay="0" @change="onSwipeChange" class="my-swipe">
            <van-swipe-item v-for="(img, idx) in pageData.imageVideoList" :key="idx" @click="previewImages(idx)">
              <img :src="img.fileCompress || img.imageSmall" class="swipe-img" />
            </van-swipe-item>
            <template #indicator>
              <div class="custom-indicator">
                {{ currentSwipe + 1 }} / {{ pageData.imageVideoList.length }}
              </div>
            </template>
          </van-swipe>
        </div>

        <!-- 视频渲染 (type === 2) -->
        <div v-else-if="pageData.type === 2 && pageData.imageVideoList && pageData.imageVideoList.length > 0" class="video-box">
          <video
            class="material-video"
            :src="pageData.imageVideoList[0].imageVideo"
            controls
            playsinline
            webkit-playsinline
            :poster="pageData.imageVideoList[0].imageSmall"
          ></video>
        </div>

        <!-- 标题 & 文本 -->
        <div class="material-text-box">
          <h1 v-if="pageData.title" class="material-title">{{ pageData.title }}</h1>
          <p v-if="pageData.content" class="material-desc">{{ pageData.content }}</p>
        </div>
      </div>

      <!-- 关联商品列表 -->
      <div class="associated-goods-section" v-if="pageData.hebingList && pageData.hebingList.length > 0">
        <div class="section-title">关联商品</div>
        <div
          v-for="goods in pageData.hebingList"
          :key="goods.id"
          class="associated-goods-card"
          @click="gotoProductDetail(goods)"
        >
          <img class="goods-avatar" :src="goods.spuImg || goods.thumbnailImg" />
          <div class="goods-meta">
            <div class="goods-title">{{ goods.name }}</div>
            <div class="goods-price-row">
              <span class="price-symbol">¥</span>
              <span class="price-num">{{ goods.finalPrice }}</span>
            </div>
          </div>
          <!-- <div class="goods-action-btn">
            <span>去购买</span>
            <van-icon name="arrow" class="btn-arrow" />
          </div> -->
        </div>
      </div>
      
      <!-- 占位底高度 -->
      <div class="bottom-placeholder"></div>
    </div>

    <!-- 底部功能栏 -->
    <div class="bottom-action-bar">
      <!-- 审核状态中，暂不显示操作栏 -->
      <div v-if="pageData.auditState === 3" class="audit-banner">
        <span>素材核查中，暂时无法进行操作</span>
      </div>

      <!-- 正常操作栏 -->
      <div v-else class="action-buttons-wrapper">
        <!-- 笔记模式底操作栏 -->
        <template v-if="pageData.model === 2">
          <div class="action-btn-item flex-btn" @click="shareMaterial">
            <img src="@/assets/home/shucaiquan_fenxianghei.png" class="btn-icon" />
            <span class="btn-label">分享笔记</span>
          </div>
          <div class="action-btn-item flex-btn" @click="collectMaterial">
            <img :src="pageData.isCollected === 1 ? require('@/assets/home/material_detail_star.png') : require('@/assets/home/material_detail_unstar.png')" class="btn-icon" />
            <span class="btn-label">{{ pageData.isCollected === 1 ? '已收藏' : '收藏笔记' }}</span>
          </div>
          <div class="action-btn-item flex-btn" @click="copyShortLink">
            <img src="@/assets/home/shucaiquan_cuzhi.png" class="btn-icon" />
            <span class="btn-label">复制链接</span>
          </div>
        </template>

        <!-- 素材模式底操作栏 -->
        <template v-else>
          <div class="action-btn-item" @click="copyText">
            <img src="@/assets/home/shucaiquan_cuzhi.png" class="btn-img-icon no-bg-icon" />
            <span class="btn-label">复制文案</span>
          </div>

          <div class="action-btn-item" @click="saveAssets">
            <img src="@/assets/home/shucaiquan_xiazai.png" class="btn-img-icon no-bg-icon" />
            <span class="btn-label">保存素材</span>
          </div>

          <div class="action-btn-item" @click="collectMaterial">
            <div class="relative-badge icon-wrapper">
              <img :src="pageData.isCollected === 1 ? require('@/assets/home/material_detail_star.png') : require('@/assets/home/material_detail_unstar.png')" class="btn-img-icon" />
              <div v-if="pageData.collectSum > 0" class="badge-dot">{{ pageData.collectSum }}</div>
            </div>
            <span class="btn-label">{{ pageData.isCollected === 1 ? '已收藏' : '收藏素材' }}</span>
          </div>

          <div class="action-btn-item" @click="shareMaterial">
            <div class="relative-badge icon-wrapper">
              <img src="@/assets/home/shucaiquan_fenxianghei.png" class="btn-img-icon" />
              <div v-if="pageData.shareSum > 0" class="badge-dot">{{ pageData.shareSum }}</div>
            </div>
            <span class="btn-label">分享素材</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview, Toast } from "vant";
import { selectArticleById, collectArticle, addUgcArticleRecord } from "@/api/home";
import { isLogin } from "@/utils/authority";

const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);

export default {
  name: "MaterialDetail",
  components: {
    TitleBarBack
  },
  data() {
    return {
      id: null,
      pageData: {},
      currentSwipe: 0,
      defaultAvatar: "https://img.yzcdn.cn/vant/cat.jpeg"
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.fetchDetail();
    } else {
      Toast.fail("素材不存在");
      setTimeout(() => {
        this.$router.go(-1);
      }, 1500);
    }
  },
  methods: {
    async fetchDetail() {
      try {
        const response = await selectArticleById(this.id);
        console.log("selectArticleById 接口返回原始数据：", response);
        if (response) {
          let page = null;
          // 双重兼容解包：如果包含 code 与 data 则提取，否则直接使用对象
          if (response.code !== undefined && response.data !== undefined) {
            if (response.code === 1) {
              page = response.data;
            } else {
              Toast.fail(response.msg || "加载数据失败");
              return;
            }
          } else {
            page = response;
          }

          if (page) {
            page.hebingList = [];
            if (page.model === 1) {
              if (page.product) {
                page.hebingList.push(page.product);
              }
            } else if (page.model === 2) {
              if (page.productList) {
                page.hebingList = [...page.productList];
              }
              if (page.description) {
                // 匹配富文本中的图片加上 class 便于控制样式
                page.description = page.description.replace(/<img/g, '<img class="rich-img"');
              }
            }
            this.pageData = page;
          } else {
            Toast.fail("解析数据失败");
          }
        } else {
          Toast.fail("加载数据失败");
        }
      } catch (err) {
        console.error("加载素材详情出错", err);
        Toast.fail("加载失败");
      }
    },
    // 格式化时间
    formatTime(gmtTime) {
      if (!gmtTime) return "";
      try {
        const date = new Date(gmtTime);
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        const hh = String(date.getHours()).padStart(2, "0");
        const mm = String(date.getMinutes()).padStart(2, "0");
        return `${y}-${m}-${d} ${hh}:${mm}`;
      } catch (e) {
        return gmtTime;
      }
    },
    onBack() {
      this.$router.go(-1);
    },
    onSwipeChange(index) {
      this.currentSwipe = index;
    },
    // 预览图片
    previewImages(startIdx) {
      if (!this.pageData.imageVideoList || this.pageData.imageVideoList.length === 0) return;
      const urls = this.pageData.imageVideoList.map(item => item.fileCompress || item.imageSmall);
      ImagePreview({
        images: urls,
        startPosition: startIdx
      });
    },
    // 关联商品跳转
    gotoProductDetail(goods) {
      if (!goods || !goods.id) return;
      this.$router.push({
        path: "/product/detail",
        query: { id: goods.id }
      });
    },
    // 收藏 / 点赞
    async collectMaterial() {
      if (!isLogin()) {
        Toast("请先登录");
        return;
      }
      try {
        const res = await collectArticle({ articleId: this.id });
        if (res) {
          Toast(res.data);
          let sum = this.pageData.collectSum || 0;
          let isCollected = this.pageData.isCollected;
          if (res.data === "取消成功") {
            isCollected = 0;
            sum = Math.max(0, sum - 1);
          } else if (res.data === "收藏成功") {
            isCollected = 1;
            sum += 1;
            // 埋点上报
            this.reportRecord(1);
          }
          this.pageData.isCollected = isCollected;
          this.pageData.collectSum = sum;
        }
      } catch (err) {
        console.error("操作失败", err);
      }
    },
    // 复制文案
    copyText() {
      const contentText = this.pageData.content || "";
      this.doCopy(contentText);
      // 复制打点
      this.reportRecord(5);
    },
    // 复制短链 (笔记模式)
    copyShortLink() {
      if (this.pageData.shareUrl) {
        this.doCopy(this.pageData.shareUrl);
        Toast("链接已复制");
      } else {
        this.doCopy(window.location.href);
        Toast("链接已复制");
      }
    },
    // 原生复制辅助方法
    doCopy(text, showToast = true) {
      if (!text) return false;
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      let success = false;
      try {
        document.execCommand("copy");
        success = true;
        if (showToast) {
          Toast("复制成功");
        }
      } catch (err) {
        if (showToast) {
          Toast.fail("复制失败");
        }
      }
      document.body.removeChild(textArea);
      return success;
    },
    // 强制异步下载图片到本地（若遇跨域/环境拦截将自动降级为大图预览）
    async forceDownloadImage(url) {
      try {
        const response = await fetch(url, { mode: "cors" });
        if (!response.ok) throw new Error("下载响应异常");
        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = `素材_${new Date().getTime()}.png`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(objectUrl);
        return true;
      } catch (err) {
        console.warn("异步强制下载失败，降级为预览模式：", err);
        return false;
      }
    },
    // 保存素材
    async saveAssets(isShare = false) {
      if (!this.pageData.imageVideoList || this.pageData.imageVideoList.length === 0) {
        Toast("无可处理的素材");
        return;
      }
      // 自动静默复制素材文案
      const contentText = this.pageData.content || "";
      this.doCopy(contentText, false);

      const toastMessage = isShare 
        ? "素材已保存到相册，文案已复制到粘贴板，可跳转微信自主分享"
        : "素材已保存到相册，文案已复制到粘贴板";

      // H5 下载逻辑
      if (this.pageData.type === 1) {
        // 图片型素材：尝试强制异步下载
        Toast.loading({ message: "正在处理...", forbidClick: true, duration: 0 });
        const imageUrl = this.pageData.imageVideoList[this.currentSwipe]?.fileCompress || this.pageData.imageVideoList[this.currentSwipe]?.imageSmall || this.pageData.imageVideoList[0]?.imageSmall;
        const success = await this.forceDownloadImage(imageUrl);
        Toast.clear();
        
        Toast(toastMessage);
        if (!success) {
          // 降级策略：如果异步下载报错，回退大图预览供长按保存
          this.previewImages(this.currentSwipe);
        }
        
        if (isShare) {
          this.reportRecord(2); // 分享素材打点
        } else {
          this.reportRecord(6); // 下载图片打点
        }
        this.reportRecord(5); // 复制文案打点
      } else if (this.pageData.type === 2) {
        // 视频型素材：尝试通过新标签页打开或触发直接下载
        const videoUrl = this.pageData.imageVideoList[0].imageVideo;
        if (videoUrl) {
          window.open(videoUrl, "_blank");
          Toast(toastMessage);
          
          if (isShare) {
            this.reportRecord(2); // 分享素材打点
          } else {
            this.reportRecord(7); // 下载视频打点
          }
          this.reportRecord(5); // 复制文案打点
        }
      }
    },
    // 分享素材
    shareMaterial() {
      // 采用和保存相同的逻辑，附带分享专属提示语和打点
      this.saveAssets(true);
    },
    // 埋点打点请求
    async reportRecord(type) {
      try {
        const datas = [];
        if (this.pageData.imageVideoList) {
          this.pageData.imageVideoList.forEach(item => {
            datas.push({ dataId: item.id });
          });
        }
        await addUgcArticleRecord({
          articleId: this.id,
          type,
          datas
        });
        // 重新同步一下数据状态
        const freshData = await selectArticleById(this.id);
        if (freshData && freshData.code === 1 && freshData.data) {
          this.pageData.shareSum = freshData.data.shareSum || 0;
          this.pageData.collectSum = freshData.data.collectSum || 0;
        }
      } catch (e) {
        console.error("行为埋点上报失败", e);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.material-detail-container {
  min-height: 100vh;
  background-color: #f7f8fa;
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: left;
}

.author-profile {
  display: flex;
  align-items: center;
}
.author-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  margin-right: 8px;
  object-fit: cover;
  border: 1px solid #ebedf0;
}
.author-meta {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.author-name {
  font-size: 13px;
  font-weight: 600;
  color: #323233;
  line-height: 1.2;
}
.post-time {
  font-size: 10px;
  color: #969799;
  margin-top: 2px;
}

/* 内容区 */
.scroll-content {
  flex: 1;
  padding-top: 0;
  box-sizing: border-box;
  overflow-y: auto;
}

/* 轮播图 */
.swiper-box {
  width: 100%;
  position: relative;
  background-color: #fff;
  height: 65vh;
}
.my-swipe {
  width: 100%;
  height: 100%;
  background-color: #fff;
  /deep/ .van-swipe-item {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    height: 100% !important;
  }
}
.swipe-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.custom-indicator {
  position: absolute;
  right: 12px;
  bottom: 20px;
  padding: 2px 8px;
  color: #fff;
  font-size: 11px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 10px;
}

/* 视频 */
.video-box {
  width: 100%;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 65vh;
}
.material-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* 素材信息区 */
.material-text-box {
  background-color: #fff;
  padding: 16px 12px;
}
.material-title {
  font-size: 16px;
  font-weight: bold;
  color: #323233;
  line-height: 1.4;
  margin: 0 0 10px 0;
}
.material-desc {
  font-size: 14px;
  color: #5d5d5f;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
  margin: 0;
}

/* 笔记富文本 */
.rich-text-content {
  background-color: #fff;
  padding: 16px 12px;
  .v-html-body {
    font-size: 14px;
    color: #333;
    line-height: 1.6;
    /deep/ img.rich-img {
      width: 100% !important;
      height: auto !important;
      border-radius: 6px;
      margin: 8px 0;
      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
    }
  }
}

/* 关联商品区 */
.associated-goods-section {
  padding: 16px 12px;
}
.section-title {
  font-size: 14px;
  font-weight: bold;
  color: #323233;
  margin-bottom: 10px;
}
.associated-goods-card {
  display: flex;
  padding: 8px;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 8px;
  cursor: pointer;
  transition: transform 0.1s ease;
  &:active {
    transform: scale(0.98);
  }
}
.goods-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 10px;
  object-fit: cover;
  background-color: #f7f8fa;
  flex-shrink: 0;
}
.goods-meta {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 10px;
}
.goods-title {
  font-size: 12px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
}
.goods-price-row {
  margin-top: 4px;
  display: flex;
  align-items: baseline;
  line-height: 1;
}
.price-symbol {
  font-size: 10px;
  color: #ee0a24;
  font-weight: 500;
  margin-right: 1px;
}
.price-num {
  font-size: 13px;
  color: #ee0a24;
  font-weight: 600;
}
.goods-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 12px;
  background-color: #ee0a24;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  flex-shrink: 0;
  .btn-arrow {
    font-size: 10px;
    margin-left: 2px;
  }
}

.bottom-placeholder {
  height: 66px;
}

/* 底部功能栏 */
.bottom-action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 99;
  padding: 10px 12px;
  box-sizing: border-box;
}
.audit-banner {
  text-align: center;
  color: #f5222d;
  font-size: 13px;
  padding: 8px 0;
}
.action-buttons-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.action-btn-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.1s ease;
  &:active {
    transform: scale(0.92);
  }
  
  .icon-wrapper {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 4px;
    position: relative;
  }
  .btn-img-icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
    display: block;
    &.no-bg-icon {
      margin-bottom: 4px;
    }
  }
  .btn-label {
    font-size: 10px;
    color: #646566;
  }
}

/* 笔记模式下的横排按钮样式 */
.action-btn-item.flex-btn {
  flex: 1;
  height: 36px;
  border-radius: 18px;
  background-color: #f7f8fa;
  border: 1px solid #ebedf0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 0 4px;
  
  .btn-icon {
    width: 14px;
    height: 14px;
    margin-right: 4px;
    display: block;
  }
  .btn-icon-van {
    font-size: 14px;
    margin-right: 4px;
  }
  .btn-label {
    font-size: 11px;
    font-weight: 500;
    color: #323233;
  }
  
  &:active {
    background-color: #ebedf0;
    transform: scale(0.96);
  }
}

/* 消息角标 */
.relative-badge {
  position: relative;
}
.badge-dot {
  position: absolute;
  top: -4px;
  right: -6px;
  background-color: #ee0a24;
  color: #fff;
  font-size: 8px;
  font-weight: 600;
  padding: 1px 4px;
  border-radius: 7px;
  border: 1px solid #fff;
  line-height: 1;
}

</style>
